import { render, staticRenderFns } from "./App.vue?vue&type=template&id=472cff63&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=472cff63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472cff63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mihailoff/apps/quantify-github/services/connect/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472cff63')) {
      api.createRecord('472cff63', component.options)
    } else {
      api.reload('472cff63', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=472cff63&scoped=true&", function () {
      api.rerender('472cff63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "App.vue"
export default component.exports